export enum LiveSideNavigationInteractionTypeEnum {
	Upcoming = "Upcoming",
	Highlights = "Highlights",
	LiveStream = "LiveStream",
}
